import * as React from 'react';
import { useOutletContext, Link, useLocation } from 'react-router-dom';
import { Outlet, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Helmet } from 'react-helmet';
import {
  Paper,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  CircularProgress,
} from '@mui/material';
import { useAccount } from '../context/AccountContext';
import { ORG_TYPES, USER_ROLES } from '../common/AppConstants';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PersonIcon from '@mui/icons-material/Person';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import TransferWithinAStationOutlinedIcon from '@mui/icons-material/TransferWithinAStationOutlined';
// import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
// import ApartmentIcon from '@mui/icons-material/Apartment';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useIsMobile } from "./karyakramaTheme";
import SubscriptionBanner from './SubscriptionBanner';
import { PRODUCT_NAME } from '../common/AppConstants';
import * as AppUrls from '../common/AppUrls';

const drawerWidth = 240;

const CATEGORY_PRIMARY = 'primary';
const CATEGORY_SECONDARY = 'secondary';
const CATEGORY_BOTTOM = 'bottom';

// Update renderContent in MainLayout.js
const allMenuItems = [
  {
    label: 'Home',
    route: AppUrls.DASHBOARD_URL,
    icon: HomeOutlinedIcon,
    filledIcon: HomeIcon,
    org_types: [ORG_TYPES.EDUCATION, ORG_TYPES.FITNESS],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER, USER_ROLES.STUDENT],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'TimeTable',
    route: AppUrls.TIME_TABLE_URL,
    icon: DashboardOutlinedIcon,
    filledIcon: DashboardIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER, USER_ROLES.STUDENT],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Classrooms',
    route: AppUrls.CLASSROOM_URL,
    icon: MeetingRoomOutlinedIcon,
    filledIcon: MeetingRoomIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Subjects',
    route: AppUrls.SUBJECT_URL,
    icon: AutoStoriesOutlinedIcon,
    filledIcon: AutoStoriesIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER, USER_ROLES.STUDENT],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Teachers',
    route: AppUrls.TEACHER_URL,
    icon: PersonOutlinedIcon,
    filledIcon: PersonIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Student Groups',
    route: AppUrls.SECTION_URL,
    icon: GroupsOutlinedIcon,
    filledIcon: GroupsIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_PRIMARY,
  },
  // {
  //   label: 'Students',
  //   route: '/dashboard/students',
  //   icon: SchoolOutlinedIcon,
  //   filledIcon: SchoolIcon,
  //   org_types: [ORG_TYPES.EDUCATION],
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.STUDENT],
  //   category: CATEGORY_PRIMARY,
  // },
  {
    label: 'Subject Class',
    route: AppUrls.SUBJECT_CLASS_URL,
    icon: HistoryEduOutlinedIcon,
    filledIcon: HistoryEduIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Staff Attendance',
    route: AppUrls.STAFF_ATTENDANCE_URL,
    icon: AssignmentOutlinedIcon,
    filledIcon: AssignmentIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Substitutes',
    route: AppUrls.STAFF_SUBSTITUTE_URL,
    icon: TransferWithinAStationOutlinedIcon,
    filledIcon: TransferWithinAStationIcon,
    org_types: [ORG_TYPES.EDUCATION],
    // Admin/Admin Viewer, a Teacher gets their own cover duties on the home timeline
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER],
    category: CATEGORY_PRIMARY,
  },
  // Staff Absence is hidden, the daily attendance flow replaces it
  // {
  //   label: 'Staff Absence',
  //   route: AppUrls.STAFF_ABSENCE_URL,
  //   icon: TransferWithinAStationOutlinedIcon,
  //   filledIcon: TransferWithinAStationIcon,
  //   org_types: [ORG_TYPES.EDUCATION],
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER, USER_ROLES.TEACHER],
  //   category: CATEGORY_PRIMARY,
  // },
  {
    label: 'Template',
    route: AppUrls.TEMPLATE_URL,
    icon: SettingsOutlinedIcon,
    filledIcon: SettingsIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_SECONDARY,
  },
  {
    label: 'Manage TimeTable',
    route: AppUrls.CREATE_TIME_TABLE_URL,
    icon: DashboardCustomizeOutlinedIcon,
    filledIcon: DashboardCustomizeIcon,
    org_types: [ORG_TYPES.EDUCATION],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_SECONDARY,
  },
  {
    label: 'Staff',
    route: AppUrls.TRAINER_URL,
    icon: PersonOutlinedIcon,
    filledIcon: PersonIcon,
    org_types: [ORG_TYPES.FITNESS],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Members',
    route: AppUrls.MEMBER_URL,
    icon: GroupsOutlinedIcon,
    filledIcon: GroupsIcon,
    org_types: [ORG_TYPES.FITNESS],
    roles: [USER_ROLES.ADMIN, USER_ROLES.ADMIN_VIEWER],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Payments',
    route: AppUrls.FITNESS_PAYMENT_URL,
    icon: ReceiptOutlinedIcon,
    filledIcon: ReceiptIcon,
    org_types: [ORG_TYPES.FITNESS],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_PRIMARY,
  },
  {
    label: 'Account',
    route: AppUrls.ACCOUNT_URL,
    icon: SettingsOutlinedIcon,
    filledIcon: SettingsIcon,
    org_types: [ORG_TYPES.EDUCATION, ORG_TYPES.FITNESS],
    roles: [USER_ROLES.ADMIN],
    category: CATEGORY_BOTTOM,
  },
];

const DashboardLayout = () => {
  const isMobile = useIsMobile();
  const { loggedIn, authLoading } = React.useContext(AuthContext);
  const context = useOutletContext() || {};
  const { toggleDrawer, open } = context;

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const location = useLocation();
  const { account } = useAccount();

  // Filter menu items based on user role
  const getFilteredMenuItems = (category) => {
    return allMenuItems.filter(item => 
      item.category === category &&
      item.org_types.includes(account?.organization?.org_type?.toLowerCase()) &&
      item.roles.includes(account?.user?.current_role?.toLowerCase())
    );
  };

  const primaryMenuItems = getFilteredMenuItems(CATEGORY_PRIMARY);
  const secondaryMenuItems = getFilteredMenuItems(CATEGORY_SECONDARY);
  const bottomMenuItems = getFilteredMenuItems(CATEGORY_BOTTOM);

  // Helper function to render menu items
  const renderMenuItems = (items, onClick) => {
    return items.map((item) => (
      <ListItemButton
        key={item.label}
        component={Link}
        to={item.route}
        selected={location.pathname === item.route}
        onClick={onClick}
      >
        <ListItemIcon>
          {location.pathname === item.route ? (
            <item.filledIcon sx={{ color: 'primary.main' }} />
          ) : (
            <item.icon />
          )}
        </ListItemIcon>
        <ListItemText primary={item.label} />
      </ListItemButton>
    ));
  };

  // Ensure we only show loading screen on the first load
  useEffect(() => {
    if (!authLoading) {
      setIsFirstLoad(false); // After the first check, never show full loader again
    }
  }, [authLoading]);

  if (authLoading && isFirstLoad) {
    console.log('CircularProgress');
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!loggedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <>
      <Helmet>
        <title>{`${PRODUCT_NAME} | Dashboard`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <Box
        sx={{
          height: 'calc(100vh - 64px)' , // viewport height - app bar
          display: 'flex',
          // backgroundColor: "#f6f8fb",
        }}
      >
        {/* Column 1 - Side Nav */}
        { !isMobile ? (  // Desktop Version, Hidden on Mobile and Tab
          <Box
            sx={{
              height: 'calc(100vh - 64px)' , // viewport height - app bar
            }}
          >
            <Drawer
              variant="permanent"
              open={open}
              // component={Paper}
              ModalProps={{ keepMounted: true }} // Improves performance
              sx={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
                width: open ? drawerWidth : 60, // Adjust the width for open and collapsed states
                overflowX: 'hidden', // Hide horizontal scroll
                borderRight: 'none', // Remove right border
                borderLeft: 'none', // Remove left border
                height: 'inherit',
                '& .MuiDrawer-paper': {
                  borderLeft: 'none',
                  whiteSpace: 'nowrap',
                  position: 'relative',
                  overflowX: 'hidden', // Hide horizontal scroll
                  width: drawerWidth,
                },
              }}
              PaperProps={{
                sx: {
                  borderRight: 'none', // Ensure Paper does not have a right border
                  borderLeft: 'none', // Remove left border
                  // backgroundColor: "#f6f8fb"
                },
              }}
            >
              <Box backgroundColor="#fffff" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Primary Menu List */}
                {primaryMenuItems.length > 0 && (
                  <List component="nav">
                    {renderMenuItems(primaryMenuItems)}
                  </List>
                )}

                {/* Divider - only show if both primary and secondary menus have items */}
                {primaryMenuItems.length > 0 && secondaryMenuItems.length > 0 && (
                  <Divider sx={{ mx: 2 }} />
                )}

                {/* Secondary Menu List */}
                {secondaryMenuItems.length > 0 && (
                  <List component="nav">
                    {renderMenuItems(secondaryMenuItems)}
                  </List>
                )}

                {/* Bottom Menu List */}
                <Box sx={{ mt: 'auto', mb: '8px'  }}>
                  {bottomMenuItems.length > 0 && (
                    <List component="nav">
                      {renderMenuItems(bottomMenuItems, toggleDrawer)}
                    </List>
                  )}
                </Box>
              </Box>
            </Drawer>
          </Box>

        ) : ( // Mobile and Tab Version, Hidden on desktop
          <Box
            sx={{
              height: 'calc(100vh - 64px)' , // viewport height - app bar
            }}
          >
            <Drawer
              variant="temporary"
              open={open}
              onClose={toggleDrawer}
              // component={Paper}
              ModalProps={{ keepMounted: true }} // Improves performance
              sx={{
                // flexDirection: 'column',
                overflow: 'auto',
                width: open ? drawerWidth : 60, // Adjust the width for open and collapsed states
                overflowX: 'hidden', // Hide horizontal scroll
                borderRight: 'none', // Remove right border
                borderLeft: 'none', // Remove left border
                height: 'inherit',
                marginTop: '64px',  // Moves the drawer below app bar
                '& .MuiDrawer-paper': {
                  borderLeft: 'none',
                  whiteSpace: 'nowrap',
                  position: 'relative',
                  overflowX: 'hidden', // Hide horizontal scroll
                  width: drawerWidth,
                },
              }}
              PaperProps={{
                sx: {
                  borderRight: 'none', // Ensure Paper does not have a right border
                  borderLeft: 'none', // Remove left border
                  // backgroundColor: "#f6f8fb"
                },
              }}
            >
              <Box backgroundColor="#fffff" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Primary Menu List */}
                {primaryMenuItems.length > 0 && (
                  <List component="nav">
                    {renderMenuItems(primaryMenuItems, toggleDrawer)}
                  </List>
                )}

                {/* Divider - only show if both primary and secondary menus have items */}
                {primaryMenuItems.length > 0 && secondaryMenuItems.length > 0 && (
                  <Divider sx={{ mx: 2 }} />
                )}

                {/* Secondary Menu List */}
                {secondaryMenuItems.length > 0 && (
                  <List component="nav">
                    {renderMenuItems(secondaryMenuItems, toggleDrawer)}
                  </List>
                )}

                {/* Bottom Menu List */}
                <Box sx={{ mt: 'auto', mb: '8px' }}>
                  {bottomMenuItems.length > 0 && (
                    <List component="nav">
                      {renderMenuItems(bottomMenuItems, toggleDrawer)}
                    </List>
                  )}
                </Box>
              </Box>
            </Drawer>
          </Box>
        )}

        {/* Column 2 - Main content */}
        <Box
          sx={{
            flexGrow: 1, // Remaining horizontal space
            overflow: 'auto',
            height: 'calc(100vh - 64px)' , // viewport height - app bar
          }}
        >
          <Paper
            sx={{
              py: 2,
              px: 1,
              // height: "inherit",
              height: 'calc(100vh - 64px)' , // viewport height - margings - app bar
            }}
          >
            <SubscriptionBanner />
            <Outlet context={{ toggleDrawer, open }} />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
